// extracted by mini-css-extract-plugin
module.exports = {"Header":"LogPage_Header__3z87F","HeaderText":"LogPage_HeaderText__1TcQO","vertical":"LogPage_vertical__3k88U","Back":"LogPage_Back__3j8x0"};